<template>
  <div class="bottom" :style="{ left: objData ? '':(initwidth - marginLeft)/2 - 250 + marginLeft + 'px' }">
    <div class="modelButton">
      <div v-for="(item,index) in operList" :key="item.query" class="operButton" :title="item.name"
        :class="{'active':item.isActive, 'hoverActive':item.hoverActive}" @click.stop="openFun(item,index)"
        @mouseover="mouseover(item)" @mouseleave="mouseleave(item)">
        <img v-if="item.isActive || item.hoverActive" :src="item.icon1" alt="图标" class="mainImage">
        <img v-else :src="item.icon" alt="图标" class="mainImage">
        <img v-if="item.hasMark === 'on' " src="./../images/markOn.png" alt="角标" class="mark">
        <img v-else-if="item.hasMark === 'off' " src="./../images/markOff.png" alt="角标" class="mark">
      </div>
      <div v-if="measureBoolean" class="measureFunc">
        <span v-for="item in measureFuncList" :key="item.query" :class="{'isActiveMList':item.isActive}" class="mList"
          @click="measureActFun(item)">
          <span class="iconRed" :class="{'active':item.isActive}"></span>
          <img :src="item.icon" :title="item.name" alt="" srcset="">
          <span>{{ item.name }}</span>
        </span>
      </div>
      <div v-show="sectionBoolean" class="sectionFunc">
        <span v-for="item in sectionFuncList" :key="item.query" :class="{'isActiveMList':item.isActive}" class="mList"
          @click="sectionActFunc(item)">
          <span class="iconRed" :class="{'active':item.isActive}"></span>
          <img :src="item.icon" :title="item.name" alt="" srcset="">
          <span>{{ item.name }}</span>
        </span>
      </div>
      <div v-show="componentColorBoolean" class="componentColorFunc">
        <div v-for="(item,index) in componentColorFuncList" :key="index" class="item"
          @click="componentColorFuncClick(item)">
          <img :src="require(`./../images/${item.name}.png`)" :alt="item.name">
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div v-show="componentQuaFlow" class="componentQuaFlow">
        <div v-for="(item,index) in popoNavList" :key="index" class="item"
          @click="componentQuaFlowClick(item)">
          <!-- <img :src="require(`./../images/${item.name}.png`)" :alt="item.name"> -->
          <span>{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";

import { mapState } from "vuex";

export default {
  props:{
    objData: {
      type: Object,
      required: false
    }, 
  },
  data() {
    return {
      popoNavList:[],
      componentQuaFlow:false,
      updateKey:0,
     
      quaListFlow:[
        {
          name: "创建质量管理流程",
          icon: require("./../images/创建流程.png"),
          icon1: require("./../images/创建流程s.png"),
          query: "setFlow",
          isActive: false,
          hoverActive: false
        },
        {
          name: "流程清单",
          icon: require("./../images/流程清单.png"),
          icon1: require("./../images/流程清单s.png"),
          query: "detailList",
          isActive: false,
          hoverActive: false
        }
      ],
      operList: [
        {
          name: "框选放大",
          icon: require("./../images/框选放大.png"),
          icon1: require("./../images/框选放大s.png"),
          query: "amplifications",
          isActive: false,
          hoverActive: false
        },
        {
          name: "测量",
          icon: require("./../images/测量.png"),
          icon1: require("./../images/测量s.png"),
          query: "meaure",
          isActive: false,
          hoverActive: false,
          hasMark: "off"
        },
        {
          name: "剖切",
          icon: require("./../images/剖切.png"),
          icon1: require("./../images/剖切s.png"),
          query: "sectionFunc",
          isActive: false,
          hoverActive: false,
          hasMark: "off"
        },
        {
          name: "模型对比",
          icon: require("./../images/模型对比.png"),
          icon1: require("./../images/模型对比s.png"),
          query: "modelCompare",
          isActive: false,
          hoverActive: false
        },
        {
          name: "构件颜色",
          icon: require("./../images/构件颜色.png"),
          icon1: require("./../images/构件颜色s.png"),
          query: "componentColor",
          isActive: false,
          hasMark: "off"
        },
        {
          name: "小地图",
          icon: require("./../images/小地图.png"),
          icon1: require("./../images/小地图s.png"),
          query: "minimap",
          isActive: false,
          hoverActive: false
        },
        {
          name: "设置",
          icon: require("./../images/设置.png"),
          icon1: require("./../images/设置s.png"),
          query: "set",
          isActive: false,
          hoverActive: false
        },
        {
          name: "创建批注",
          icon: require("./../images/创建批注.png"),
          icon1: require("./../images/创建批注s.png"),
          query: "issue",
          isActive: false,
          hoverActive: false
        },
        {
          name: "批注列表",
          icon: require("./../images/批注列表.png"),
          icon1: require("./../images/批注列表s.png"),
          query: "list",
          isActive: false,
          hoverActive: false
        },
      ],
      measureFuncList: [
        {
          name: "标高测量",
          icon: require("./../images/标高测量.png"),
          query: "level",
          isActive: false
        },
        {
          name: "面对面",
          icon: require("./../images/面对面.png"),
          query: "face",
          isActive: false
        },
        {
          name: "角度测量",
          icon: require("./../images/角度测量.png"),
          query: "angle",
          isActive: false
        },
        {
          name: "距离测量",
          icon: require("./../images/距离测量.png"),
          query: "distance",
          isActive: false
        },
        {
          name: "最小距离",
          icon: require("./../images/最小距离.png"),
          query: "mini",
          isActive: false
        },
        {
          name: "清除测量",
          icon: require("./../images/清除测量.png"),
          query: "close",
          isActive: false
        }
      ],
      sectionFuncList: [
        {
          name: "X轴",
          icon: require("./../images/X轴.png"),
          query: "X",
          isActive: false
        },
        {
          name: "Y轴",
          icon: require("./../images/Y轴.png"),
          query: "Y",
          isActive: false
        },
        {
          name: "Z轴",
          icon: require("./../images/Z轴.png"),
          query: "Z",
          isActive: false
        },
        {
          name: "盒子",
          icon: require("./../images/盒子.png"),
          query: "box",
          isActive: false
        },
        {
          name: "截取面",
          icon: require("./../images/截取面.png"),
          query: "art",
          isActive: false
        },
        {
          name: "清除剖切",
          icon: require("./../images/清除测量.png"),
          query: "close",
          isActive: false
        }
      ],
      componentColorFuncList: [
        { name: "设置颜色", query: "select" },
        { name: "恢复颜色", query: "clear" }
      ],
      markLogo: false,
      measureBoolean: false,
      sectionBoolean: false,
      componentColorBoolean: false,
      initwidth: 1920,
      marginLeft: 0
    };
  },
  computed: {
    ...mapState({
      currentComponent: state => state.monge.currentComponent,
      enterpriseId: (state) => state.enterprise.enterpriseId,
    })
  },

  mounted() {
    this.initwidth = document.body.clientWidth;
    if (this.$route.query.noNeedIssue) {
      this.operList = this.operList.filter( ele => ele.name !== "创建批注" && ele.name !== "批注列表" );
      if(this.$route.query.noquaFlow){
        this.operList = this.operList.concat(this.quaListFlow);
      }
    }else if(this.objData&&this.objData.noNeedIssue){
      this.operList = this.operList.filter(ele=>ele.name!=="创建批注" && ele.name!=="批注列表")
    }
    console.log(this.$parent.$refs.modelView.showdwg);
  },
  methods: {
    openFun(item, index) {
      this.operList.forEach(ele => {
        if (ele.query == item.query) {
          item.isActive = !item.isActive;
        } else {
          if (ele.hasMark) {
            ele.hasMark = "off";
          }
          ele.isActive = false;
        }
      });
      Monge.Model.Measure.deactive();
      Monge.Model.Zoom.deactive();
      this.measureBoolean = false;
      this.sectionBoolean = false;
      this.componentQuaFlow=false;
      this.componentColorBoolean = false;
      this.$parent.showminimaplevel = false;
      Monge.Model.MiniMap.deactive();
      this.$parent.$refs.modelSet.closeArea();
      this.$parent.$refs.addModelNotation.closeAdd();
      this.$parent.$refs.listNotation.closeList();
      this.$parent.$refs.detailNotation.closeArea();
      this.$parent.$refs.modelCompare.close();
      this.$parent.$refs.quaFlowList.closeList();
      switch (item.query) {
        case "amplifications":
          Monge.Model.Zoom.active({
            continuous: false,
            callback: type => {
              if (type === Monge.CallbackType.DONE) {
                item.isActive = !item.isActive;
              }
            }
          });
          break;
        case "meaure":
          if (item.isActive) {
            this.measureFuncList.forEach(ele => (ele.isActive = false));
            // this.markLogo = true;
            item.hasMark = "on";
            this.measureBoolean = true;
          } else {
            item.hasMark = "off";
          }
          break;
        case "sectionFunc":
          if (item.isActive) {
            // this.sectionFuncList.forEach(ele=>ele.isActive = false)
            item.hasMark = "on";
            this.sectionBoolean = true;
          } else {
            item.hasMark = "off";
          }
          break;
        case "minimap":
          if (item.isActive) {
            this.$parent.showminimaplevel = true;
            Monge.Model.MiniMap.deactive();
            this.$parent.getLevels();
          }
          break;
        case "set":
          this.$parent.$refs.modelSet.openSet();
          setTimeout(() => {
            item.isActive = !item.isActive;
          }, 300);
          break;
        case "issue":
          if (item.isActive) {
            this.$parent.$refs.addModelNotation.showAdd();
            item.isActive = !item.isActive;
          }
          break;
        case "list":
          if (item.isActive) {
            this.$parent.$refs.listNotation.openList();
            item.isActive = !item.isActive;
          }
          break;
        case "componentColor":
          if (item.isActive) {
            item.hasMark = "on";
            this.componentColorBoolean = true;
          } else {
            item.hasMark = "off";
            this.$parent.$refs.componentColor.close();
          }
          break;
        case "modelCompare":
          this.$parent.$refs.modelCompare.open();
          setTimeout(() => {
            item.isActive = !item.isActive;
          }, 300);
          break;
        case "setFlow":
          if (item.isActive) {
            this.getTree();
            item.isActive = !item.isActive;
            this.componentQuaFlow=true;
          }
          break;
        case "detailList":
          if (item.isActive) {
            this.$parent.$refs.quaFlowList.openList();
            item.isActive = !item.isActive;
          }
          break;
      }
    },
    measureActFun(item) {
      this.measureFuncList.forEach(ele => {
        if (ele.query == item.query) {
          item.isActive = !item.isActive;
        } else {
          ele.isActive = false;
        }
      });
      Monge.Model.Measure.deactive();
      switch (item.query) {
        case "level":
          Monge.Model.Measure.active(
            Monge.Model.Measure.MeasureType.LEVEL,
            (type, data) => {
              if (type == Monge.CallbackType.DONE) {
                item.isActive = !item.isActive;
              }
            }
          );
          break;
        case "face":
          Monge.Model.Measure.active(
            Monge.Model.Measure.MeasureType.FACE,
            (type, data) => {
              if (type == Monge.CallbackType.DONE) {
                item.isActive = !item.isActive;
              }
            }
          );
          break;
        case "angle":
          Monge.Model.Measure.active(
            Monge.Model.Measure.MeasureType.ANGLE,
            (type, data) => {
              if (type == Monge.CallbackType.DONE) {
                item.isActive = !item.isActive;
              }
            }
          );
          break;
        case "distance":
          Monge.Model.Measure.active(
            Monge.Model.Measure.MeasureType.DISTANCE,
            (type, data) => {
              if (type == Monge.CallbackType.DONE) {
                item.isActive = !item.isActive;
              }
            }
          );
          break;
        case "mini":
          debugger;
          Monge.Model.Measure.active(
            Monge.Model.Measure.MeasureType.MINI,
            (type, data) => {
              if (type == Monge.CallbackType.DONE) {
                item.isActive = !item.isActive;
              }
            }
          );
          break;
        case "close": // 清除测量
          if (item.isActive) {
            Monge.Model.Measure.clear();
            item.isActive = !item.isActive;
          }
          break;
      }
    },
    sectionActFunc(item) {
      this.sectionFuncList.forEach(ele => {
        if (ele.query == item.query) {
          item.isActive = !item.isActive;
        } else {
          ele.isActive = false;
        }
      });
      Monge.Model.Section.deactive();
      switch (item.query) {
        case "X":
          this.$store.dispatch("setSectionType", "x");
          Monge.Model.Section.active({ mode: "x" });
          break;
        case "Y":
          this.$store.dispatch("setSectionType", "y");
          Monge.Model.Section.active({ mode: "y" });
          break;
        case "Z":
          this.$store.dispatch("setSectionType", "z");
          Monge.Model.Section.active({ mode: "z" });
          break;
        case "box":
          this.$store.dispatch("setSectionType", "box");
          Monge.Model.Section.active({ mode: "box" });
          break;
        case "art":
          this.$store.dispatch("setSectionType", "art");
          Monge.Model.Section.sectionBySelection();
          break;
        case "close":
          Monge.Model.Section.deactive();
          item.isActive = !item.isActive;
          break;
      }
    },

    componentColorFuncClick({ query }) {
      if (query === "select") {
        const { modelId, elementId } = this.currentComponent;
        if (modelId && elementId) {
          this.$parent.$refs.componentColor.open();
        } else {
          this.$message.warning("请先选择您想要设置颜色的构件");
        }
      } else {
        this.$parent.$refs.componentColor.close();
        this.$store.dispatch("currentComponent", {});
        Monge.Model.Selector.cancelSelect();
        Monge.Model.ElementOperator.resetAllColor();
        this.$message.success("颜色恢复成功");
      }
    },
    mouseover(item) {
      item.hoverActive = true;
    },
    mouseleave(item) {
      item.hoverActive = false;
    },
    //创建流程的类型
    async getTree() {
      const res = await flowService.queryGroupInfoList(this.enterpriseId);
      if(this.$route.query.noquaFlow==="0"){
        this.popoNavList=res.data.find(item=> item.flowGroupDto.name=="质量巡检")?.flowDefinitionDtoList
      }else if(this.$route.query.noquaFlow==="1"){
        this.popoNavList=res.data.find(item=> item.flowGroupDto.name=="安全巡检")?.flowDefinitionDtoList
      }
    },
    componentQuaFlowClick(val){
      let params= {
        status: null,
        currentVersionId: val.currentVersionId,
        iconPrefix: val.iconPrefix,
        groupId: val.groupId || "",
        flowDefinitionId: val.id,
        name: val.name,
        flowDescribe: val.flowDescribe,
        flowKey: val.flowKey,
        flowInstanceId: val.flowInstanceId,
        flowBusinessId: val.flowBusinessId,
      };
      this.$store.dispatch("setRouterParams", params);
      this.$parent.$refs.quaFlow.open()
    },
    
  },
};
</script>
<style lang="scss" scoped>
.bottom {
  position: absolute;
  width: 500px;
  height: 100px;
  bottom: 23px;
  left: calc(50% - 200px);
}
.modelButton {
  position: absolute;
  bottom: 23px;
  left: calc(50% - 250px);
  width: 600px;
  height: 50px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  z-index: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  .operButton {
    width: 40px;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .mainImage {
      cursor: pointer;
    }
    .mark {
      width: 5px;
      height: 5px;
      position: absolute;
      bottom: 18px;
      right: 0;
      cursor: pointer;
    }
  }
}
.measureFunc,
.sectionFunc {
  position: absolute;
  bottom: 55px;
  left: 30px;
  // left: calc(50% - 200px);
  width: 114px;
  height: 250px;
  background: rgba(255, 255, 255, 0.9);
  // box-shadow: 0px 0px 8px 2px rgba(97, 110, 139, 0.78);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 10px 0;
  // z-index: 2;
  .mList {
    width: 100%;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    // color: #fff;
    cursor: pointer;
    span {
      font-size: 14px;
      line-height: 38px;
    }
    .iconRed {
      width: 4px;
      height: 4px;
      border-radius: 4px;
      margin-left: 5px;
    }
    .active {
      background: #ff0000;
    }
    img {
      margin: 0 5px;
      width: 22px;
      height: 22px;
    }
  }
  .isActiveMList {
    background-color: #fff;
    background: rgba(56, 115, 254, 0.18);
  }
  .mList:hover {
    background-color: #fff;
    background: rgba(56, 115, 254, 0.18);
    // .iconRed{
    //   background: #FF0000;
    // }
  }
}
.sectionFunc {
  left: 80px;
}
.componentColorFunc,.componentQuaFlow {
  position: absolute;
  left: calc(50% - 55px);
  bottom: 55px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .item:hover {
    background: rgba(56, 115, 254, 0.13);
  }
  .item {
    display: flex;
    align-items: center;
    height: 38px;
    width: 100px;
    justify-content: center;
    cursor: pointer;
    span {
      margin-left: 5px;
    }
  }
}
.componentQuaFlow{
  left: calc(100% - 170px);
}
</style>
